//-------------------------------------------------------------------------------------------------- Imports
import { StyleSheet } from "../StyleSheet";
import { images } from "../routes/ImageRoutes";

//-------------------------------------------------------------------------------------------------- Component
const MeganLoading = () => {
    return (
        <div style={styles.mainContainer}>
            <img style={styles.loadingGif} src={images.loadingMegan} alt="loading" />
            <h3 style={{ color: "#9108E4" }}>Cargando...</h3>
        </div>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    mainContainer: {
        display: "flex",
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        backgroundColor: "transparent",
    },
    loadingGif: {
        width: 100,
        height: 100,
    }
});

//-------------------------------------------------------------------------------------------------- Exports
export default MeganLoading;
